'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require('semantic-ui-react');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchContent = function (_Component) {
  (0, _inherits3.default)(SearchContent, _Component);

  function SearchContent(props) {
    (0, _classCallCheck3.default)(this, SearchContent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SearchContent.__proto__ || (0, _getPrototypeOf2.default)(SearchContent)).call(this, props));

    _this.resultRenderer = function (_ref) {
      var name = _ref.name,
          pk = _ref.pk;
      return _react2.default.createElement(_semanticUiReact.Label, { key: pk, onClick: function onClick() {
          return _this.props.selectTemplate(pk);
        }, style: { width: '100%' }, content: name });
    };

    _this.resetComponent = function () {
      return _this.setState({ isLoading: false, results: [], value: '' });
    };

    _this.handleResultSelect = function (event, result) {
      return _this.setState({ value: result.name });
    };

    _this.handleSearchChange = function (event, value) {
      _this.setState({ isLoading: true, value: value });

      setTimeout(function () {
        if (_this.state.value.length < 1) return _this.resetComponent();

        var re = new RegExp(_lodash2.default.escapeRegExp(_this.state.value), 'i');
        var isMatch = function isMatch(result) {
          return re.test(result.name);
        };

        _this.setState({
          isLoading: false,
          results: _lodash2.default.filter(_this.state.data, isMatch)
        });
      }, 500);
    };

    _this.state = {
      raw_data: _this.props.data
    };
    return _this;
  }

  (0, _createClass3.default)(SearchContent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // Converting the object to an iterable array.
      var arr = [];
      for (var key in this.state.raw_data) {
        arr = arr.concat(this.state.raw_data[key].data);
      }
      // Setting array to state
      this.setState({ data: arr });

      this.resetComponent();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          isLoading = _state.isLoading,
          value = _state.value,
          results = _state.results;


      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          _react2.default.createElement(_semanticUiReact.Search, {
            placeholder: 'Search for profiles...',
            loading: isLoading,
            onResultSelect: this.handleResultSelect,
            onSearchChange: this.handleSearchChange,
            results: results,
            value: value,
            resultRenderer: this.resultRenderer,
            style: this.props.style
          })
        )
      );
    }
  }]);
  return SearchContent;
}(_react.Component);

exports.default = SearchContent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchContent/SearchContent.js
// module id = 1743
// module chunks = 0